import { render, staticRenderFns } from "./EmailInfoCard.vue?vue&type=template&id=13d8e2a0&"
import script from "./EmailInfoCard.vue?vue&type=script&lang=js&"
export * from "./EmailInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports